"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SmsIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4 0a4 4 0 00-4 4v6a4 4 0 004 4h6a4 4 0 004-4V4a4 4 0 00-4-4H4zm.64 3.505l.855 1.425a.5.5 0 01-.06.595l-.197.215a.48.48 0 00-.066.568C5.828 7.425 6.739 8.332 7.97 9.16c.267.18.627.048.729-.257l.102-.306a.5.5 0 01.736-.268l.771.473c.374.23.56.683.33 1.057a2.823 2.823 0 01-.138.204 1.131 1.131 0 01-.072.086c-.822.889-2.274.481-3.28-.192-2.023-1.352-2.922-2.53-3.772-4.414a2.04 2.04 0 01-.062-1.484l.04-.12c.093-.281.295-.513.56-.646a.558.558 0 01.727.212z",
    clipRule: "evenodd"
  })))
});
SmsIcon.displayName = 'SmsIcon';
var _default = exports.default = SmsIcon;